import { Button, Stack } from '@mui/material';
import useAuth from 'hooks/useAuth';
import useUser from 'hooks/useUser';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router';
import MainCard from 'views/components/cards/MainCard';
import EditAddDocumentModal from 'views/components/clinic-documents/modal/EditAddDocumentModal';
import Documents from 'views/pages/documents';

const ClinicDocumentId = () => {
  const intl = useIntl();
  const { userId } = useAuth();
  const { isNousSupport } = useUser(userId);
  const [uploadingDocument, setUploadingDocument] = useState(false);

  const { documentId } = useParams();

  return (
    <MainCard
      title={intl.formatMessage({ defaultMessage: 'Clinic Documents' })}
      secondary={
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button variant="contained" onClick={() => setUploadingDocument(true)}>
            <FormattedMessage defaultMessage="Upload Documents" />
          </Button>
        </Stack>
      }
    >
      {uploadingDocument && <EditAddDocumentModal onClose={() => setUploadingDocument(false)} editingFolderId={documentId} />}

      <Documents />
    </MainCard>
  );
};

export default ClinicDocumentId;
